import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import AppErrorBoundary from './components/utils/AppErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// Felgränsen ligger YTTERST, runt <App /> — utanför ThemePreferenceProvider,
// AppScene, BrowserRouter och alla gater. Ett renderingsfel i vilket som helst av
// de lagren gav tidigare vit skärm; nu ger det en läsbar skärm med en väg vidare.
root.render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
